import { render, staticRenderFns } from "./CustoForm.vue?vue&type=template&id=992717d4"
import script from "./CustoForm.vue?vue&type=script&lang=js"
export * from "./CustoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports